// RTCRtpReceiver.getCapabilities is absent in older browsers and may return null;
// the RTP mime type for HEVC is "video/H265" (RFC 7798)
export function isVideoH265Capable() {
  const codecs = window.RTCRtpReceiver?.getCapabilities?.('video')?.codecs
  return !!codecs?.some(codec => codec.mimeType?.toLowerCase() === 'video/h265')
}
